/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseForAgentResponse {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return BaseForAgentResponse.fixupPrototype; }

    static newInstance(model: Partial<BaseForAgentResponse>): BaseForAgentResponse {
        let obj = Object.assign(new BaseForAgentResponse(), model);
        BaseForAgentResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseForAgentResponse>): BaseForAgentResponse {
        if (!model) return null;
        return BaseForAgentResponse.newInstance(<BaseForAgentResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseForAgentResponse) {
        if (!obj) return;

        models.BaseForAgentResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseForAgentResponse): boolean {
        switch (obj.__type)
        {
            case "ActionForm":
                Object.setPrototypeOf(obj, models.ResponseForAgentActionForm.prototype);
                break;
            case "Chart":
                Object.setPrototypeOf(obj, models.ResponseForAgentChart.prototype);
                break;
            case "HtmlPage":
                Object.setPrototypeOf(obj, models.ResponseForAgentHtmlPage.prototype);
                break;
            case "InsightPanel":
                Object.setPrototypeOf(obj, models.ResponseForAgentInsightPanel.prototype);
                break;
            case "Limitation":
                Object.setPrototypeOf(obj, models.ResponseForAgentLimitation.prototype);
                break;
            case "Table":
                Object.setPrototypeOf(obj, models.ResponseForAgentTable.prototype);
                break;
            case "Text":
                Object.setPrototypeOf(obj, models.ResponseForAgentText.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof BaseForAgentResponse)[] {
        return [
            models.ResponseForAgentActionForm,
            models.ResponseForAgentChart,
            models.ResponseForAgentHtmlPage,
            models.ResponseForAgentInsightPanel,
            models.ResponseForAgentLimitation,
            models.ResponseForAgentTable,
            models.ResponseForAgentText,
        ];
    }

    fixupFields() {
    }

}
